// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.analytics.boostpreview.RentalManagerUserAnalyticsBoostPreviewWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CpmBoostAdPreviewsDto } from '../..';

interface GetV2Params {
  insertionOrderId: string;
  isSingleFamily?: boolean;
}

export const RentalManagerUserAnalyticsBoostPreviewWebApiHandler_getV2_Path =
  '/api/web/v1/users/analytics/boostPreview/getV2';

/**
 * Get boost ad previews to show in Ad Spend page.
 */
export const RentalManagerUserAnalyticsBoostPreviewWebApiHandler_getV2 = (
  getParams: GetV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetV2Params, never, CpmBoostAdPreviewsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserAnalyticsBoostPreviewWebApiHandler_getV2_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
